import { Link } from "react-router-dom";
import DataBar from "../../components/ui/alerts/DataBar";
import { getLanguageContent } from "../../utils/language/languageSelector";
import { HOME_SCHEMA } from "../../utils/schemas/language/pages/homeSchema";
import ClosingPage from "../../components/common/Closing";
import PublicFooterV2 from "../../components/ui/PublicFooterV2";
import FAQPreview from "../../components/common/FAQPreview";
import AffiliateBanner from "../common/affiliates/AffiliateBanner";
import ClassicHowItWork from "../../components/ui/hiw/ClassicHowItWork";
import DecodeBannerArticles from "../common/articles/DecodeBannerArticles";
import ProductEcosystem from "../../components/landing/parallax/home/ProductEcosystem";

function Home({ langKey }) {
  const content = getLanguageContent(HOME_SCHEMA, langKey);

  return (
    <>
      <main className="public">
        <section
          id="heroBanner"
          style={{
            backgroundColor: "#001c34",
          }}
        >
          <div className="content ">
            <div className="content-header-intro">
              <h1>{content.hero_heading}</h1>
              <p style={{ fontSize: "1.4rem" }}>{content.hero_description}</p>
              <Link to="sign-up" className="cta-button secondary">
                {content.cta_hero}
              </Link>
            </div>
            <div>
              <img
                src={process.env.PUBLIC_URL + "/images/home_avatars_banner.svg"}
                alt={content.hero_image_alt}
                loading="lazy"
              />
            </div>
          </div>
        </section>

        <DataBar langKey={langKey} />

        <section className="fullsize-white-container">
          <div className="content">
            <ClassicHowItWork
              title={content.how_it_works.title}
              steps={content.how_it_works.steps}
            />
          </div>
        </section>
        <section className="fullsize-light-blue-container">
          <div className="content">
            <ProductEcosystem content={content.product_ecosystem} />
          </div>
        </section>
        <section className="fullsize-white-container">
          <div className="content">
            <DecodeBannerArticles content={content.blog} />
          </div>
        </section>
        <section className="fullsize-white-container disable-padding-container">
          <div className="content">
            <div>
              <AffiliateBanner content={content.affiliates} />
            </div>
          </div>
        </section>
        <section className="fullsize-white-container">
          <div className="content">
            <FAQPreview
              title={content.faq.heading}
              faqs={content.faq.items}
              ctaText={content.faq.cta}
              toggleAlt={content.faq.toggle_alt}
            />
          </div>
        </section>
        <ClosingPage
          title={content.closing_page.heading}
          description={content.closing_page.description}
          imageAlt={content.closing_page.image_alt}
          image="network_map_svg.svg"
          ctas={content.closing_page.ctas}
          containerClasses="padding-full"
        />
      </main>
      <PublicFooterV2 langKey={langKey} />
      <script src="main.js"></script>
    </>
  );
}

export default Home;
